import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Json } from '@ff-os/shared-json/Json';
import { urls } from '@ff-os/shared-utils/urls';
import { fetchFn } from './_fetch';

export const publicAssets = createApi({
    baseQuery: fetchBaseQuery({ fetchFn }),
    endpoints: build => ({
        getUrlsInCollection: build.query<string[], string>({
            query: id => ({ url: urls.loadCollection(id) }),
            transformResponse: (response: Json.Collection) =>
                response.entries.map(e => e.url)
        })
    })
});